import React from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-rangeslider';
import { ShowZoomModal } from './buttons';
import { virtualCueOptions } from '../../constants/images';

const inputPropTypes = {
	updateAnswer: PropTypes.func,
	answers: PropTypes.array,
	language: PropTypes.string,
	currentValue: PropTypes.string,
	countryCode: PropTypes.string
};

const AnswersTextRadio = (props) => {
	const answers = props.answers.map((entry) => (
		<li key={entry.value}>
			<input type="radio"
						 onChange={props.updateAnswer}
						 checked={entry.value === props.currentValue}
						 name="answers"
						 id={`answers-${entry.value}`}
						 value={entry.value}/>
			{entry.text && <label htmlFor={`answers-${entry.value}`}>{entry.text[props.countryCode]}</label>}
		</li>
	));

	return <ul className="list grid--max-1 grid--stretch-h-1x">{answers}</ul>;
};

const AnswersMatrixTextRadio = (props) => {
	const answers = props.answers.map((entry) => (
		<li key={entry.value}>
			<input type="radio"
						 onChange={props.updateAnswer}
						 checked={entry.value === props.currentValue}
						 name="answers"
						 id={`answers-${entry.value}`}
						 value={entry.value}/>
			<label htmlFor={`answers-${entry.value}`}>
				{entry.text[props.countryCode]}
			</label>
		</li>
	));

	return <ul className={`list grid--max-2 grid--stretch-h-1x`}>{answers}</ul>;
};

AnswersTextRadio.propTypes = inputPropTypes;

const AnswersImageRadio = (props) => {
	const answers = props.answers.map((entry) => {
		return (
			<li key={entry.value}>
				<input type="radio"
							 onChange={props.updateAnswer}
							 checked={entry.value === props.currentValue}
							 name="answers"
							 id={`answers-${entry.value}`}
							 value={entry.value}/>
				<label htmlFor={`answers-${entry.value}`}>
					<img src={virtualCueOptions[entry.image]}/>
				</label>
				<ShowZoomModal zoomIn={props.zoomIn} image={entry.image}/>
			</li>
		)
	});

	const gridClass = props.answers.length === 2 ? 'grid--max-2' : 'grid--max-4';

	return <ul className={`list ${gridClass} grid--stretch-h-1x`}>{answers}</ul>;
};

AnswersImageRadio.propTypes = inputPropTypes;

const AnswersRange = (props) => {
	let val = props.currentValue === '' ? 0 : props.currentValue;
	return <Slider
		min={props.range.min}
		max={props.range.max}
		step={props.range.step}
		value={parseInt(val)}
		onChange={props.updateAnswer}/>
}

AnswersRange.propTypes = {
	...inputPropTypes,
	answers: PropTypes.object
};

export {
	AnswersTextRadio,
	AnswersImageRadio,
	AnswersRange,
	AnswersMatrixTextRadio
};
